// extracted by mini-css-extract-plugin
export default {"Horizontal":"Horizontal_Horizontal__Xv1UG","VerHorizontaltical":"Horizontal_VerHorizontaltical__4rz4B"};